import { render } from 'react-dom'
import './styles.css'
import * as THREE from 'three'
import { useRef, Suspense, useEffect, useState } from 'react'
import { Canvas, useFrame, useThree, extend } from '@react-three/fiber'
import { Center, Bounds, Instances, Instance } from '@react-three/drei'
import * as Tone from 'tone'
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass'
import { AfterimagePass } from 'three/examples/jsm/postprocessing/AfterimagePass'
let randI = (i) => Math.floor(i * fxrand())
let rand = (arr) => arr[randI(arr.length)]
import allColors from './Colors'

let ci = randI(allColors.length)
let cols = allColors[ci]
let bg = cols.shift()
const feats = window.$fxhashFeatures = {}
let damp = 1
class AfterBurn extends AfterimagePass { constructor() { super(1); this.shaderMaterial.onBeforeCompile = (shader) => { shader.fragmentShader = `uniform float damp;uniform sampler2D tOld;uniform sampler2D tNew;varying vec2 vUv;vec4 when_gt( vec4 x, float y ) {return max( sign( x - y ), 0.000000001 );} void main() { vec4 texelOld = texture2D( tOld, vUv ); vec4 texelNew = texture2D( tNew, vUv ); texelOld *= damp * when_gt( texelOld, 0.0000000001 );gl_FragColor = max(texelNew, texelOld);}` } } }
extend({ EffectComposer, RenderPass, AfterBurn })
const Tint = () => {
  const ref = useRef()
  const { size, gl, scene, camera } = useThree()
  console.log(scene, camera, gl, size)
  const composer = useRef()
  useFrame(() => {
    ref.current.uniforms.damp.value = damp
    composer.current.render()
    damp = 1
  }, 1)
  return (
    <effectComposer ref={composer} args={[gl]}><renderPass attachFns={['addPass']} args={[scene, camera]} /><afterBurn attachFns={['addPass']} args={[size]} ref={ref} /></effectComposer>
  )
}
let padLength = 16
Tone.Transport.bpm.value = 10
let pads = new Array(padLength).fill().map(() => {
  let am = new Tone.AMSynth({
    "harmonicity": 0.025,
    "oscillator": {
      "type": "amsine2",
      "modulationType": "sine",
      "harmonicity": rand([1.01, 1.02, 1.01, 1.015, 1.0175, 1.0125, 1.01, 1.002]) * 0.0000000000001
    },
    "envelope": {
      "attack": '8n',
      "decay": '1m',
      "sustain": 0.5,
      "release": '1m'
    },
    "modulation": {
      "volume": rand([3, 5, 8, 10, 15]) * 0.25,
      "type": "amsine2",
      "modulationType": "sine",
      "harmonicity": rand([4, 8, 12, 16]) * 4
    },
    "modulationEnvelope": {
      "attack": '32n',
      "decay": 0.2,
      "sustain": 0.5,
      "release": '1m'
    }
  })
  let mainGain = new Tone.Gain(1).toDestination()
  let delay = new Tone.PingPongDelay(rand(['32t', '32n']), 0.9).toDestination()
  am.connect(new Tone.Gain(rand([0.03, 0.01, 0.1, 0])).connect(mainGain.connect(delay)))
  am.connect(new Tone.Gain(rand([0.1, 0.2, 0])).connect(new Tone.Panner((-10 + randI(20)) * 0.1).connect(mainGain)))
  return am
})

Tone.context.lookAhead = 0.1
let notes = new Array(24).fill().map(() => rand(['C', 'D', 'E', 'F', 'A']) + rand([3, 4]))
const click = () => {
  if (!started) {
    Tone.start();
    Tone.Transport.start();
    started = true
  }
  pads.forEach((p, pi) => {
    p.triggerAttackRelease(rand(notes), '8n', '+0.00001', 0.5 + (randI(20) * 0.03))
  })
  damp = 0
  dampCount = 0
  setDefault()
}

const c = 180 + randI(200);
const G = 1;
const dt = 0.25;
let particlesAmt = 1024 * 2
let massMult = rand([70, 80,100, 150, 200, 250, 300, 400, 400, 500])
let fr = (Math.PI * rand(randI(100) > 10 ? [2, 3, 3, 4, 4, 6] : [1.25, 1.5])) / particlesAmt
let width = 15
let positions, vels, thetas, running, scales, holeMass;
let holeAmt = 4 + randI(50)
let hidden = new Array(particlesAmt).fill().map((_, i) => false);
let setDefault = () => {
  positions = new Array(particlesAmt).fill().map((_, i) => new THREE.Vector2(Math.sin((i * fr)) * width, Math.cos((i * fr)) * width));
  vels = new Array(particlesAmt).fill().map((_, i) => new THREE.Vector2(0, 0));
  thetas = new Array(particlesAmt).fill().map((_, i) => Math.PI * 10);
  running = new Array(particlesAmt).fill().map((_, i) => true);
  hidden = new Array(particlesAmt).fill().map((_, i) => false);
  scales = new Array(particlesAmt).fill().map((_, i) => 1);
  holeMass = new Array(holeAmt).fill().map((_, i) => 2000 * (1 + ((1 + randI(massMult)) * 0.1)))
}
let holeSize = new Array(holeAmt).fill().map((_, i) => ((1 + randI(20)) * 0.02))
let colChance = rand([250 + randI(50)])
setDefault()
let currCol = rand(cols)
let colors = []
new Array(particlesAmt).fill().map((_, i) => {
  if (randI(300) > colChance) {
    currCol = rand(cols)
  }
  colors.push(currCol)
});
let hfr = (Math.PI * rand([2, 2, 2, 1.5, 1])) / holeAmt
let hOffset = rand([(randI(10) * 0.5) * rand([1, -1]), 0])
let hWidth = width * ((4 + randI(16)) * 0.05)
let holePos = new Array(holeAmt).fill().map((_, i) => new THREE.Vector2(hOffset + Math.sin((i * hfr)) * hWidth, Math.cos(i * hfr) * hWidth))

export default function App() {
  const size = useWindowSize();
  useEffect(() => {
    setDefault()
  }, [size.width])
  return (
    <div id="main" onClick={() => click()} key={size.width}>
      <Canvas flat={true} linear={true} dpr={[1, 2]} camera={{ near: 0.001, far: 10000, position: [0, 0, 300], fov: 10 }}>
        <color attach="background" args={[bg]} />
        <Bounds fit margin={1.3} damping={0}>
          <Center>
            <group rotation={[0, 0, randI(1000) * 0.01]}>
              <Things />
            </group>
          </Center>
        </Bounds>
        <Tint />
        <ambientLight intensity={1} />
        <directionalLight position={[0, 1, 1]} intensity={1} />
        <directionalLight position={[0, -1, -1]} intensity={1} />
      </Canvas>
    </div>
  )
}
let dampCount = 0
function Things() {
  useFrame(() => {
    positions.forEach((_, i) => {
      if (running[i]) {
        updateParticle(i)
        pullParticle(i)
      }
    })
    count++;
    if (!(count % 30) && started) {
      dampCount++
      if (dampCount < 25) {
        damp = 0.99
      } else {
        running = new Array(particlesAmt).fill().map((_, i) => false);
      }

    }
  })
  return (
    <Instances limit={10000} geometry={geo} material={new THREE.MeshStandardMaterial()}>
      {
        new Array(particlesAmt).fill().map((_, i) =>
          <Thing i={i} key={i} />
        )
      }
    </Instances>
  )
}
let count = 0
let m = rand([0])
let modesMult = [
  rand([0.1, 0.2, 0.5, 1, 2]) * (1 + randI(10)),
  rand([0.1, 0.2, 0.5, 1, 2]) * 20,
]
function Thing({ i }) {
  const ref = useRef();
  useFrame(() => {
    ref.current.position.x = positions[i].x
    ref.current.position.y = positions[i].y
    if (running[i]) {
      ref.current.scale.setScalar(modes[m](0, i * modesMult[0], count * modesMult[1]))
    } else {
      ref.current.scale.setScalar(0)
    }
  })
  return (
    <Instance ref={ref} position={[positions[i].x, positions[i].y, 0]} color={colors[i]} />
  )
}

let geo = new THREE.OctahedronBufferGeometry(0.04);
let started = false;

console.log('%c🍾 @ramioso 2022-09-23 🍾', 'color: orange');
render(
  <Suspense fallback={null}>
    <App />
  </Suspense>
  ,
  document.getElementById('root')
)
function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });
  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return windowSize;
}

function updateParticle(i) {
  let deltaV = vels[i].clone();
  deltaV.multiplyScalar(dt);
  positions[i].add(deltaV);
}
function pullParticle(i) {
  holePos.forEach((_, j) => {
    const force = holePos[j].clone().sub(positions[i])
    const theta = force.angle();
    const r = force.length();
    if (r <= holeSize[j]) {
      running[i] = false
    }
    const fg = G * holeMass[j] / (r * r);
    let deltaTheta = -fg * (dt / c) * Math.sin(thetas[i] - theta);
    deltaTheta /= Math.abs(1.0 - 2.0 * G * holeMass[j] / (r * c * c));
    thetas[i] += deltaTheta;
    vels[i] = new THREE.Vector2(Math.cos(thetas[i]), Math.sin(thetas[i]))
    vels[i].multiplyScalar(c * scalar);
  })
}
let scalar = rand([0.004, 0.003, 0.002, 0.002, 0.003, 0.005])

let modes = [
  (t, c, r) => Math.cos(t * 1 + Math.sqrt(c * r * 0.05)) + .5,
  (t, c, r) => Math.cos(2 * r / c ^ 2 + t),
  (t, c, r) => Math.max(0, Math.sin(r ^ (c + 9 * t))),
  (t, c, r) => Math.min(0, c / r * (Math.hypot(c + Math.cos(t) - (columns * 0.5), r - (rows * 0.5)) - 5)),
  (t, c, r) => Math.cos(c / 3 + Math.cos(r / 5 + t * 0.1) * 4) * 2,
  (t, c, r) => Math.tan(Math.sin(r / 3 - t * 2) + Math.cos(c / 2 - t * 3)),
  (t, c, r) => .02 / Math.sin(3 ** ++c - Math.atan2(c, c * r) * 3 - t),
  (t, c, r) => r / 4 & (c - 8) / r + t * 4,
  (t, c, r) => ((c * r) % (8 + Math.floor(t % 8))) > 6 ? 1 : -.5,
  (t, c, r) => (c + r < Math.max(rows, columns)) * ((c + r) < Math.ceil(Math.max(rows, columns) * 0.5) ? 1 : -1) || (c - r < 1),
  (t, c, r) => [7, 5, 3, 1].reduce((a, b) => r > a + a / 2 * Math.cos(c / a + (gt * 2) * a) ? -a / 3 : b),
  (t, c, r) => [8, 5, 3, 1].reduce((a, b) => r > a + a / 2 * Math.cos(c / a + gt * a) ? -a / 5 : b),
  (t, c, r) => ((c + (r + t * 9) ^ c - (r + t * 9)) % 13 & 1) - .15,
  (t, c, r) => Math.sin(c / 8 + t) % Math.sin(r + t),
  (t, c, r) => Math.sin(2 * Math.atan2(r - 8, c) + t),
  (t, c, r) => c < 13 ? ((Date.now() + '')[c] - 5) / 5 : 0,
  (t, c, r) => Math.sin(t) * 5 * Math.sin(r / 5) * Math.sin(c / 5) % 1,
  (t, c, r) => ((4 * 9 + c - r * Math.tan(4) ^ c * Math.tan(4) + r) & 8) - 4,
  (t, c, r) => Math.sin(t * r * c / ((r * columns) + c) * 10),
]